import { useEffect } from "react";

/**
 * Subscribe to UHF RFID scans pushed by the native PDA wrapper App
 * (https://order.drrt.com.au accessed via the DrrtPda WebView).
 *
 * The wrapper fires a `pda-rfid-scan` CustomEvent whenever the warehouse
 * operator presses "Stop & Send" after a burst — the detail is shaped as
 * `{ epcs: string[] }`. We expose just the array.
 *
 * Multiple components may mount this hook at the same time; ALL of them
 * receive the same array, so the screen the operator is currently on
 * decides what to do with it (e.g. inventory register textarea fills
 * itself, delivery burst queue absorbs them, etc.).
 *
 * Pass `enabled=false` (or just unmount the component) to stop listening.
 */
export function usePdaScan(onEpcs, { enabled = true } = {}) {
  useEffect(() => {
    if (!enabled) return undefined;
    const handler = (e) => {
      const epcs = e?.detail?.epcs;
      if (Array.isArray(epcs) && epcs.length > 0) onEpcs(epcs);
    };
    window.addEventListener("pda-rfid-scan", handler);
    return () => window.removeEventListener("pda-rfid-scan", handler);
  }, [enabled, onEpcs]);
}

/** True when running inside the DRRT PDA wrapper App (sets UA "DrrtPda/x"). */
export function isInPdaWrapper() {
  if (typeof navigator === "undefined") return false;
  return /\bDrrtPda\//i.test(navigator.userAgent || "");
}
